class Presse {
  constructor () {
    this.loginPresse();
    if (document.querySelector('.user-form')) {
      this.titles();
      this.validation();
      this.msgRegister();
      document.querySelector('.form-cancel').addEventListener('click', function () {
        history.back();
      });
    }
    $('.field--type-telephone a, input[type="tel"]').mask('00 00 00 00 00');
  }

  titles () {
    let page = document.querySelector('.user-form')
    let parent = document.querySelector('#block-fcpe-content')
    let title = document.createElement('h2')
    if (page.classList.contains('user-register-form')) {
      title.innerHTML = 'Création de compte'
    } else {
      title.innerHTML = 'Modification de compte'
    }
    parent.insertBefore(title, parent.firstChild)
  }

  validation () {
    let form = document.querySelector('.user-form')
    form.setAttribute('novalidate', 'novalidate')
    let inputs = form.querySelectorAll('.form-item:not([class*=form-item-pass-pass]) > input')
    inputs.forEach(function (elem) {
      if (elem.classList.contains('required') || elem.id === 'edit-current-pass') {
        let classeName = 'validate[required]'
        if (elem.classList.contains('form-tel')) {
          classeName = 'validate[required,custom[phone]]'
          elem.setAttribute('maxlength', '14')
        } else if (elem.classList.contains('form-email')) {
          classeName = 'validate[required,custom[email]]'
        }
        elem.classList.add(classeName)
        elem.parentNode.querySelector('label').innerHTML += '*'
      }
    })
    $(form).bind('submit', function (ev) {
      ev.preventDefault()
      let valid = $(form).validationEngine('validate')
      if (valid) {
        $(form).unbind('submit')
        $(form).submit()
      }
    })
  }

  msgRegister () {
    let urlParams = new URLSearchParams(window.location.search)
    let msg = urlParams.get('msg')
    let linkPresse = urlParams.get('linkPresse')
    let form = document.querySelector('form.user-form')
    if (form && form.classList.contains('user-register-form')) {
      document.querySelector('#block-fcpe-local-tasks').style.display = 'none'
    }
    if (msg) {
      form.style.opacity = 0.2
      form.querySelectorAll('input').forEach(function (elem) {
        elem.setAttribute('disabled', 'disabled')
      })
      let displayMsg = document.createElement('span')
      if(linkPresse){
        displayMsg.innerHTML = (decodeURI(msg) + '. <a href="/espace-presse">Accédez à votre espace connecté</a>')
      }
      else{
        displayMsg.innerHTML = decodeURI(msg)
      }
      displayMsg.classList.add('msg-inscription')
      document.querySelector('#block-fcpe-content').appendChild(displayMsg)
    }
  }

  loginPresse () {
    if(!$('body').hasClass('user-logged-in')){
      let btnPresse = $('nav#block-espacepersonnel ul.menu>li:last-child')
      let loginPresseModal = document.querySelector('div#block-loginpresseblock');

      $(btnPresse).click(function(ev){
        ev.preventDefault()
        $(loginPresseModal).addClass('open');
      })
      $(loginPresseModal).find('.icon-close').click(function(){
        $(loginPresseModal).removeClass('open');
      })
    }
  }
}

export default Presse
